import React from "react";
import MenuButton from "./MenuButton";

const SupportOptions = ({ actions }) => {
  const phoneNumber = "+919930404202";
  const landline = "020-40065077";
  const whatsappLink = `https://wa.me/${phoneNumber.replace("+", "")}`;

  return (
    <div className="w-full">
      <button
        onClick={() => (window.location.href = `tel:${landline}`)}
        className="border border-customBlue hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        ☎️ 020-40065077
      </button>

      {/* Call Us Button */}
      <button
        onClick={() => (window.location.href = `tel:${phoneNumber}`)}
        className="border border-customBlue hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        📞 +91 9930404202
      </button>

      {/* WhatsApp Button */}
      <button
        onClick={() => window.open(whatsappLink, "_blank")}
        className="border border-customBlue hover:bg-gray-100 py-0.5 px-2 m-1 rounded-full"
      >
        💬 +91 9930404202
      </button>

      <MenuButton actions={actions} />
    </div>
  );
};

export default SupportOptions;
